module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_35"
    }
  }, [_c('span', [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e365035"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c4_r1#d6e6",
      "id": "d7e6"
    }
  }, [_vm._v("3 "), _c('br'), _c('br'), _c('i', [_vm._v("Fathers and Sons ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph",
    attrs: {
      "id": "d7e365835"
    }
  }, [_c('span', [_c('i', [_vm._v("Men show their characters in nothing more clearly than in what they think laughable.")])])]), _vm._v(" "), _c('p', {
    staticClass: "extbd",
    attrs: {
      "id": "d7e366635"
    }
  }, [_c('span', [_vm._v("—J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHANN ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLFGANG VON")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OETHE ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e367135"
    }
  }, [_c('span', [_vm._v("The tradition of humorous characterizations in C. S. Lewis’s fiction appears as much in rich, complex personalities as it does in true comic sketches. The characters he knew in real life were much more interesting than anyone he could draw from imagination. His brother, Warnie, was once described as an “amiable, baggy-trousered walrus.” John Wain called Warnie a man who had dressed up to look like Lewis with a mustache. He was a jolly Watson to his rational Holmesian brother.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e369735"
    }
  }, [_c('span', [_vm._v("Their father, Albert Lewis, however, was a character out of Dickens or Sterne. Lewis’s difficulty with his father is well documented. The strain of their relationship brought anger, anguish, and guilt upon the son. But Lewis and his easygoing brother saw the humorous side of it as well. On one occasion he may have been preaching to himself when, while having lunch with a father and son, he observed “that son would have borne patiently and humorously from any other old man the silliness which enraged him in his father.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d57",
      "id": "a57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" In stepping out of one’s own self-centeredness, one gains a sense of perspective that allows not only for charity but for the comic spirit as well.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e373635"
    }
  }, [_c('span', [_vm._v("Lewis’s father was notorious for his convoluted logic and misuse of names. When Warnie spoke about a reunion dinner for the officers of his company, the following exchange took place:"), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e374935"
    }
  }, [_c('span', [_c('b', [_vm._v("FATHER: ")]), _vm._v("I suppose your friend Collins was there.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e375635"
    }
  }, [_c('span', [_c('b', [_vm._v("BROTHER: ")]), _vm._v("Collins? Oh no. He wasn’t in the Nth, you know.")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_36"
    }
  }, [_c('span', [_vm._v("26")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e376836"
    }
  }, [_c('span', [_c('b', [_vm._v("FATHER: ")]), _vm._v("(after a pause) Did these fellows not like Collins then?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e378036"
    }
  }, [_c('span', [_c('b', [_vm._v("BROTHER: ")]), _vm._v("I don’t quite understand. What fellows?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e378936"
    }
  }, [_c('span', [_c('b', [_vm._v("FATHER: ")]), _vm._v("The Johnnies that got up the dinner.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e379836"
    }
  }, [_c('span', [_c('b', [_vm._v("BROTHER: ")]), _vm._v("Oh no, not at all. It was nothing to do with liking or not liking. You see, it was purely a Divisional affair. There’d be no question of asking anyone who hadn’t been in the Nth.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e381936"
    }
  }, [_c('span', [_c('b', [_vm._v("FATHER: ")]), _vm._v("(after a long pause) Hm! Well, I’m sure poor Collins was very much hurt."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d58",
      "id": "a58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e383436"
    }
  }, [_c('span', [_vm._v("Lewis explained his affection for his utterly distinctive father by drawing parallels to the odd and whimsical spirit of son and father in Sterne’s classic, "), _c('i', [_vm._v("Tristram Shandy")]), _vm._v(". Lewis’s Irish solicitor patriarch had “more power of confusing an issue or taking up a fact wrongly than any man I have ever known.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d59",
      "id": "a59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" His father would retain an answer or a fact in a shape very unlike what had been given him, producing through sentiment, imagination, and lively humor his own version of the facts.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e386936"
    }
  }, [_c('span', [_vm._v("As he invariably got proper names wrong (no name seemed to him less probable than another) his "), _c('i', [_vm._v("textus receptus ")]), _vm._v("was often almost unrecognizable. Tell him that a boy called Churchwood had caught a field mouse and kept it as a pet, and a year, or ten years later, he would ask you, “Did you ever hear what became of poor Chickweed who was so afraid of rats?”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d60",
      "id": "a60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e389836"
    }
  }, [_c('span', [_vm._v("The “ludicrous disproportion” between his father’s “grandiloquent harangues and their occasions” reminded Lewis of the “advocate in Martial who thunders about all the villains of Roman history, while meantime "), _c('i', [_vm._v("lis est de tribus capellis")]), _vm._v("—This case, I beg the court to note/Concerns a trespass by a goat.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d61",
      "id": "a61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" It was a tempest in a teapot, the ridiculous dressed sublimely.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e393036"
    }
  }, [_c('span', [_vm._v("Albert Lewis seems remarkably like a model of one of Lewis’s good Narnian dwarfs, old Trumpkin. In "), _c('i', [_vm._v("The Silver Chalice")]), _vm._v(", Trumpkin is the elderly Lord Regent of Prince Caspian. Two British children brought into Narnia are introduced to this aging, stubborn, and farcical dwarf in what appears to be a British music hall sketch. (Lewis did not appear to share his father’s and brother’s taste for vaudeville, being sensitive toward and sympathetic at the humiliation of any failed “turn” or act; but he did apparently glean the form of silly exchange of a comic old buffoon and his charge.) When an owl introduces the two strangers, the routine begins:")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_37"
    }
  }, [_c('span', [_vm._v("27")])]), _vm._v(" "), _c('p', {
    staticClass: "exti",
    attrs: {
      "id": "d7e397437"
    }
  }, [_c('span', [_vm._v("“Rangers! What d’ye mean?” said the Dwarf, “I see two uncommonly grubby man-cubs. What do they want?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e398437"
    }
  }, [_c('span', [_vm._v("“My name’s Jill,” said Jill, pressing forward. She was very eager to explain the important business on which they had come.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e399437"
    }
  }, [_c('span', [_vm._v("“The girl’s called Jill,” said the Owl, as loud as it could.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e400137"
    }
  }, [_c('span', [_vm._v("“What’s that?” said the Dwarf. “The girls are all killed! I don’t believe a word of it. What girls? Who killed ’em?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e401237"
    }
  }, [_c('span', [_vm._v("“Only one girl, my Lord,” said the Owl. “Her name is Jill.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e401937"
    }
  }, [_c('span', [_vm._v("“Speak up, speak up,” said the Dwarf.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e402637"
    }
  }, [_c('span', [_vm._v("“Don’t stand there buzzing and twittering in my ear. Who’s been killed?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e403637"
    }
  }, [_c('span', [_vm._v("“Nobody’s been killed,” hooted the Owl.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e404337"
    }
  }, [_c('span', [_vm._v("“Who?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e405037"
    }
  }, [_c('span', [_vm._v("“"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOBODY")]), _vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e405837"
    }
  }, [_c('span', [_vm._v("“All right, all right. You needn’t shout. I’m not so deaf as all that. What do you mean by coming here to tell me that nobody’s been killed? Why should anyone have been killed?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e407137"
    }
  }, [_c('span', [_vm._v("“Better tell him I’m Eustace,” said Scrubb.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e407837"
    }
  }, [_c('span', [_vm._v("“The boy’s Eustace, my Lord,” hooted the Owl as loud as it could.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e408837"
    }
  }, [_c('span', [_vm._v("“Useless?” said the Dwarf irritably. “I dare say he is. Is that any reason for bringing him to court? Hey?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e409837"
    }
  }, [_c('span', [_vm._v("“Not useless,” said the Owl. “eustace.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_38"
    }
  }, [_c('span', [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e410838"
    }
  }, [_c('span', [_vm._v("“Used to it, is he? I don’t know what you’re talking about, I’m sure. I tell you what it is, Master Glimfeather; when I was a young Dwarf there used to be "), _c('i', [_vm._v("talking ")]), _vm._v("beasts and birds in this country who really could talk. There wasn’t all this mumbling and muttering and whispering.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d62",
      "id": "a62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e413438"
    }
  }, [_c('span', [_vm._v("Lewis’s portrait of Trumpkin reflects somewhat an affectionate description of his father. He and Warnie found irrepressible humor in their father’s communication and his harrumphing and blustering and responding to corrections with an incredulous: “Hm! Well, that’s not the story you "), _c('i', [_vm._v("used ")]), _vm._v("to tell.” One can almost imagine the two boys gently imitating their father like the young owls who imitated dwarf Trumpkin. At a parliament of owls, one owl remarks that Trumpkin was “so old now he’d only say, ‘You’re a mere chick. I remember when you were an egg. Don’t come trying to teach me, Sir. Crabs and crumpets!’")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e417438"
    }
  }, [_c('span', [_vm._v("This owl imitated Trumpkin’s voice rather well, and there were sounds of owlish laughter all round. The children began to see that the Narnians all felt about Trumpkin as people feel at school about some crusty teacher, whom everyone is a little afraid of and everyone makes fun of and nobody really dislikes."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d63",
      "id": "a63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e419538"
    }
  }, [_c('span', [_vm._v("Lewis wrote that his father, “in his armchair, sometimes appeared not so much incapable of understanding anything as determined to misunderstand everything.” Yet he saw him as a humorist and even occasionally a wit. “When he was dying, the pretty nurse, rallying him, said, ‘What an old pessimist you are! You’re just like my father.’ ‘I suppose,’ replied her patient, ‘he has "), _c('i', [_vm._v("several ")]), _vm._v("daughters.’”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d64",
      "id": "a64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e422638"
    }
  }, [_c('span', [_vm._v("In addition to these confusions of language were “the sheer "), _c('i', [_vm._v("non sequiturs ")]), _vm._v("when the ground seemed to open at one’s feet.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d65",
      "id": "a65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" This type of communication was pregnant with comic potential. Chesterton indicated playfully that communication, the “whole high human art of scripture or writing, began with a joke,” kings and priests exchanging hieroglyphic messages for good fun and making bad puns out of the similar picture-words for tax and pig."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d66",
      "id": "a66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_39"
    }
  }, [_c('span', [_vm._v("29")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e427439"
    }
  }, [_c('span', [_vm._v("The conversations of the senior Lewis were dotted and decorated with “anfractuosities,” which delighted his sons. The peculiar logic of their father attributed, for example, the origins of venereal disease to women, whence it spread to men. When asked why that was so, he answered: “Sure, how could a man have given it to a woman if he hadn’t got it from a woman himself?”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d67",
      "id": "a67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e429939"
    }
  }, [_c('span', [_vm._v("Lewis’s father left him a legacy of enjoyment of “nearly all humorous authors, from Dickens to W. W. Jacobs.” His passionate and rhetorical parent was, Lewis remembered,")])]), _vm._v(" "), _c('p', {
    staticClass: "exti",
    attrs: {
      "id": "d7e431039"
    }
  }, [_c('span', [_vm._v("almost without rival the best raconteur I have ever heard; the best, that is, of his own type, the type that acts all the characters in turn with a free use of grimace, gesture, and pantomime. He was never happier than when closeted for an hour or so with one or two of my uncles exchanging “wheezes” (as anecdotes were oddly called in our family)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d68",
      "id": "a68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e433539"
    }
  }, [_c('span', [_vm._v("Albert Lewis retained an enormous fund of these jokes for an evening’s entertainment. And Warnie, on his travels, used to collect such wheezes as were acceptable and post them home to his father.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e434939"
    }
  }, [_c('span', [_vm._v("Jack brought to Little Lea his own wheezes from Oxford, usually about peculiar characters he had encountered. One Lewis wheeze involved an undergraduate friend doing a mugger (a sort of compulsory invitation to tea with a master) at University College. His pedantic posturing brought on an attack of malapropism. Trying to impress the ladies present, he stretched his vocabulary like allegories along the Nile, mixing the terms "), _c('i', [_vm._v("salubrious ")]), _vm._v("and "), _c('i', [_vm._v("salacious")]), _vm._v(". When asked about places to spend a holiday, he replied: “Not Devonshire, it’s not very salacious.” He repeated the error when the mugger asked how he found Oxford. “Well, sir,” he answered, “it isn’t as salacious as I had hoped.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d69",
      "id": "a69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_40"
    }
  }, [_c('span', [_vm._v("30")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e439840"
    }
  }, [_c('span', [_vm._v("Another chestnut of a wheeze Lewis told his father was about a professor carrying a perforated box on a train. When a woman inquired about its contents, the professor answered that it contained a snake-eating mongoose for a friend suffering from "), _c('i', [_vm._v("delirium tremens")]), _vm._v(", who was seeing snakes. “But you don’t mean that the snakes are real?” the lady asked. “Oh dear me, no,” answered the professor, “but then neither is the mongoose.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d70",
      "id": "a70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66729bf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lind_9781595554796_epub_c10_r1.vue
// module id = 84
// module chunks = 0